// extracted by mini-css-extract-plugin
export default {"biobar-edit-favorite-product":"styles_biobar-edit-favorite-product__nu7Bu"};